import { Box } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Dropdown } from '../Dropdown';
import { DropdownItemsSection } from '../DropdownItemsSection';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon, JobErrorMessage } from '../utils';
import { TinValidationCaption } from './TinValidationCaption';
import { TinValidationRequestDataTable } from './TinValidationRequestDataTable';
import { JobExecutionStatus } from 'models/jobs/shared';
export const TinValidationCompletedResult = ({ parentJobStatus, jobStatus, requestData, tinIsMatch }) => {
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: 'TIN Match',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: tinIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !tinIsMatch,
                    hasWarning: false
                }
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [tinIsMatch]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, jobStatus: jobStatus, parentJobStatus: parentJobStatus }), title: "TIN" },
        React.createElement(Box, null,
            React.createElement(TinValidationCaption, null),
            jobStatus === JobExecutionStatus.Error ? (React.createElement(JobErrorMessage, { typeName: "TIN validation" })) : (React.createElement(React.Fragment, null,
                React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
                React.createElement(TinValidationRequestDataTable, { requestData: requestData }))))));
};
